<template>
    <div class="slide trivia-17">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="3"
                    :total="5"
                    :selectAll=true
                    :className="className" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-18",
            className: "trivia-17",
            currentTrivia: 17,
            questions: {
                question: {
                    "title": "Which of the following are common booster interview pitfalls?",
                    "answers": [
                        {"key": "A", "answer": "Building rapport with the subject"},
                        {"key": "B", "answer": "Focusing on the subject/theft rather than gaining intelligence to expand the case"},
                        {"key": "C", "answer": "Promising leniency in exchange for cooperation"},
                        {"key": "D", "answer": "Getting valuable details about what the subject intended to do with the merchandise"}
                    ],
                    "correctAnswer": ["B", "C"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-17 {
    padding: 20px 35px;

    h1 {
        font-size: 24px;
        line-height: 1.5;
    }
}
</style>
